import { Component, Input, OnInit } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { UserService } from 'app/services/user.service';
import { ZkuService } from 'app/services/zku.service';

@Component({
	selector: 'insights-tiers-sugestions',
	templateUrl: './insights-tiers-sugestions.component.html',
	styleUrls: ['./insights-tiers-sugestions.component.scss'],
})
export class InsightsTiersSugestionsComponent implements OnInit {
	@Input()
	public activeTiers: string[] = [];

	public totalEligibles = 0;
	public displayName = '';

	constructor(
		public zkuService: ZkuService,
		public userService: UserService,
		public actionTrackerService: ActionTrackerService
	) {}

	ngOnInit(): void {
		const professional = this.zkuService.getZku();
		this.displayName = professional?.displayName?.split(' ')[0];

		this.userService.getSummaryCorporate().subscribe((tiers) => {
			for (const tier of tiers) {
				if (tier.duration === 60 && !this.activeTiers.includes(tier.tier)) {
					this.totalEligibles += tier.totalEligibles;
				}
			}
		});
	}

	redirectToAccountSettings(): void {
		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Insights,
			SUBSCOPE_TYPE.Banner,
			ITEM_TYPE.TierSugestion,
			INTERACTION_TYPE.Click
		);
		window.open('/account/online-sessions?from=insights', '_self');
	}
}
